import { Source } from '../../enums/enum.source';
import { JobPolicyThresholds } from '../policies/job.policy.thresholds';
import { CodeCategory, CodeStatus, EmbeddedCodeLike } from '../shared/code';
import { CodeType } from '../shared/code.type';
import { CodeUoM } from '../shared/uom';
import { EntityStatusStamp } from '../entity.status/entity.status.stamp';
import { StageItemSecurityCapabilities } from '../../security/capabilities/job/stage/item/stage.item.security.capabilities';


export enum ClaimItemStatus {
    Linked = 'Linked',
    Unlinked = 'Unlinked',
}

export interface ClaimItem {
    _id: string;
    name: string;
    description: string;
    longDescription?: string;
    quantity: number;
    location: string;
    note: string;
    type: CodeType;
    status: CodeStatus;
    itemStatus: EntityStatusStamp,
    price: number;
    codeUoM: CodeUoM;
    category: CodeCategory;


    /* This is the _id in the contractors system */
    integrationId?: string;
    integrationDate?: Date;

    //job: Entity;
    //stage: Entity;
    system: boolean; // from tenant ?
    isLinked?: boolean;
    claimImport?: boolean;
    source?: Source;
    isReadonly?: boolean;
    allowEdit?: boolean;
    allowDelete?: boolean;
    isClaimCode?: boolean;
    /** Pending SOR lines only; the receiving tenant keeps it only where its own setting permits (D11.3). */
    workAlreadyCompleted?: boolean;
    /** What the portal caller may do to the line, answered by the server so the legacy row and the board agree (WBS-11935). */
    capabilities?: StageItemSecurityCapabilities;
}

export interface ClaimItems {
    remote: ClaimItem[];
    local: ClaimItem[];
    threshold?: JobPolicyThresholds;
}

export type PortalEditableClaimItem = Partial<Pick<ClaimItem, '_id' | 'quantity' | 'location' | 'note'>>;

export const emptyClaimItems = {
    remote: [],
    local: []
}

export const toClaimItem = (item: EmbeddedCodeLike, option?: { priceSource?: 'BUY' | 'SELL', system?: boolean, linked?: boolean, appendLongDescription?: boolean, isClaimCode?: boolean }): ClaimItem => {

    if (!item) {
        return null;
    }

    const system = option?.system ?? item.system;
    const isLinked = system ? false : option?.linked;
    const price = (option?.priceSource ?? 'BUY') === 'BUY'
        ? item.buyPrice
        : item.sellPrice;

    const result: ClaimItem = {
        _id: item._id,
        name: item.name,
        description: item.description,
        quantity: item.quantity,
        location: item.location,
        note: item.note,
        status: item.status,
        itemStatus: item.itemStatus,
        type: item.type,
        price: price,
        codeUoM: item.codeUoM,
        category: item.category,
        integrationId: item.integrationId,
        system,
        isLinked,
        source: item.source,
        isClaimCode: option?.isClaimCode,
        ...(option?.isClaimCode && item.workAlreadyCompleted === true ? { workAlreadyCompleted: true } : {}),
    };

    if (result.isClaimCode) {
        delete result.status;
    }
    else {
        delete result.itemStatus;
    }

    if (option?.appendLongDescription) {
        result.longDescription = item.longDescription;
    }

    return result;

};